import { useEffect } from 'react';
import { useIntl } from 'react-intl';

import AuthenticationStore from '~/auth/authenticationStore';
import { Box } from '~/eds/src/components/Box/Box';
import { ErrorPage } from '~/eds/src/components/ErrorPage/ErrorPage';
import { RoutePathType } from '~/routing/enums';
import { useRouting } from '~/routing/useRouting';

const AS = AuthenticationStore();

const Page = () => {
  const { navigate } = useRouting();

  const isLoggedIn = AS.isLoggedIn();
  const isEmbed = AS.isEmbed();
  const intl = useIntl();

  useEffect(() => {
    if (!isLoggedIn) {
      navigate(isEmbed ? RoutePathType.LoginEmbed : RoutePathType.Login);
    }
  }, [isLoggedIn]);

  const resolveAction = {
    text: intl.formatMessage({
      id: 'pages.404.takeMeHome',
      defaultMessage: 'Take me home',
      description: '404 page take me home button | maxLength=60',
    }),
    onClick: () => navigate('/'),
  };

  if (!isLoggedIn) {
    return null;
  }

  return (
    <Box py={16}>
      <ErrorPage
        preset="page-not-found"
        resolveAction={resolveAction}
        resolveActionText={resolveAction.text}
      />
    </Box>
  );
};

export default Page;
